import { Component, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IFabricante } from '@app/modules/fabricantes/models/fabricante.model';
import { FabricanteService } from '@app/modules/fabricantes/services/fabricante.service';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import { zip } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TokenService } from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';
import { FastParceiroComponent } from '../fast-parceiro/fast-parceiro.component';





@Component({
  selector: 'app-fast-fabricante',
  templateUrl: './fast-fabricante.component.html',
  styleUrls: ['./fast-fabricante.component.scss'],
  providers: [ParceiroService, FabricanteService]
})
export class FastFabricanteComponent {

  @ViewChild(FastParceiroComponent)
  _fastParceiro: FastParceiroComponent<IFabricante>;

  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;

  viewInit = false;

  entity: IFabricante = {
    parceiro:{
      contatos: [],
      enderecos: []
    } as IParceiro
  } as IFabricante;

  constructor(public dialogRef: MatDialogRef<FastFabricanteComponent>,
    public fabricanteService: FabricanteService,
    private tokenService: TokenService,
    private parceiroService: ParceiroService,
    public snackBar: MatSnackBar,
    private fb: UntypedFormBuilder) { }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this._fastParceiro.form.valid;
  }

  get formAddressValid(): boolean {
    if(this.viewInit && this._fastEndereco.form.invalid) this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if(this.viewInit && this._fastParceiro.form.valid) this._fastParceiro.form.markAllAsTouched();
    return this.viewInit && this._fastParceiro.form.invalid;
  }

  onSubmit(): void {
    var entity: IFabricante = Utils.clearObject<IFabricante>({
      ...this.entity,
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this._fastParceiro.getValues(),
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      })
    } as IFabricante);
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    this.insert(entity);
  }


  insert(entity: IFabricante): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.fabricanteService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, fornecedor]) => {
            return this.fabricanteService.getEntity(fornecedor.id, ['parceiro']);
          })
        )
        .subscribe(
          fornecedor => {
            this.snackBar.open('Fornecedor criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(fornecedor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.fabricanteService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(fornecedor => {
            return this.fabricanteService.getEntity(fornecedor.id, ['parceiro']);
          })
        )
        .subscribe(
          fornecedor => {
            this.snackBar.open('Fabricante criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(fornecedor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }
}
